<template>
    <div>
        <q-modal v-model="show_modal_playlist" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" @hide="hideModalListPlaylist('no-playlist')">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideModalListPlaylist('no-playlist')" icon="fas fa-times" />
                    <q-toolbar-title>
                            {{$t('playlists')}}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <q-table
                        :data="podcasts"
                        :columns="columns"
                        :pagination.sync="server_pagination"
                        @request="fetchPlayList"
                        :loading="loading"
                        :filter="filter"
                        row-key="name"
                        :no-data-label="$t('no_data_avaliable')"
                        :no-results-label="$t('no_results_found')"
                        :loading-label="$t('loading_data')"
                        :rows-per-page-label="$t('items_per_page')"
                        :rows-per-page-options="[5,10,50,100]"
                        binary-state-sort
                        >

                        <template slot="top" slot-scope="props">
                            <q-search v-model="filter" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />
                            <div class="col" />
                            <q-btn color="secondary" icon="far fa-plus" :label="$t('new_playlist')" @click="clickAddPlaylist()" />
                        </template>

                        <q-tr slot="header" slot-scope="props" :props="props">
                            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                            {{ $t(col.label) }}
                            </q-th>
                        </q-tr>

                        <q-tr slot="body" slot-scope="props" :props="props">
                            <q-td auto-width key="id" :props="props">
                                {{ props.row.id }}
                            </q-td>

                            <q-td key="title" :props="props">
                                {{ props.row.title }}
                            </q-td>

                            <q-td key="playlist" :props="props">
                                {{ props.row.playlist }}
                            </q-td>

                            <q-td key="active" :props="props">
                                <q-btn color="primary" :label="$t('add_playlist')" @click="addPlaylist(props.row)" icon="far fa-music"/>
                            </q-td>

                        </q-tr>
                    </q-table>


                </div>
            </q-modal-layout>
        </q-modal>
        <add-playlist :show="show_modal_add_plalist"  @hideModalPlayList="hideModalPlayList"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import AddPlayLists from 'components/podcasts/AddPlayLists'
export default {
    props: ['show'],
    components: {
        'add-playlist': AddPlayLists,
    },

    data(){
        return {
            show_modal_add_plalist: false,
            podcasts: [],
            filter: '',
            loading: false,
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'name',
                    sortable: false,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: false,
                },
                {
                    name: 'playlist',
                    required: true,
                    label: 'audios',
                    align: 'left',
                    field: 'playlist',
                    sortable: false,
                },
                {
                    name: 'active',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'active',
                    sortable: false,
                },
            ],
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 5,
                descending: false,
                sortBy: null
            },
            
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            tags: 'registration_lists/tags',
            playlist: 'podcasts/playlist',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        show_modal_playlist: {
            get() {
                return this.show
            },
            set(val) {
                this.title = '',
                this.description = '',
                this.tag = [],
                this.image_url = '',
                this.$v.$reset()

                this.$emit('hideModalListPlaylist', 'no-comment')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '50vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        fetchPlayList({ pagination }){
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''
            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }

            this.$axios.get(`etraining_podcast/playlist_user/?` + this.$qs.stringify(data), this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.podcasts = []

                this.podcasts = response.data.results.map(p => {
                    return {
                        id: p.id,
                        title: p.title,
                        description: p.description,
                        image_url_playlist_podcast_user: p.image_url_playlist_podcast_user,
                        tags: p.tags,
                        playlist: p.qty_podcast_playlist_audio,
                        status: p.status,
                        active: p.id,
                        audios: p.audios

                    }
                })

                this.loading = false
            })
            .catch(erro => console.log(erro))

        },

        addPlaylist(podcast){
            let new_audios = this.playlist.map(e => e.id)
            let fd = {
                'title': podcast.title,
                'audios': [...podcast.audios, ...new_audios]
            }
            this.$q.loading.show()

            this.$axios.put(`/etraining_podcast/playlist_user/${podcast.id}/`, fd, this.getHeader)
                .then(response => {
                    this.$store.dispatch('podcasts/SET_PLAYLIST', [[]])
                    this.hideModalListPlaylist('add-playlist')
                    this.$q.notify({
                        message: this.$t('playlist_save_success'),
                        type: 'positive',
                        icon: 'fal fa-save'
                    })
                })
                .catch(e => {
                    console.log(e)
                    this.$q.notify({
                        message: this.$t('unexpected_error_try_again_later'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        hideModalListPlaylist(type) {
            this.$emit('hideModalListPlaylist', type)
        },

        hideModalPlayList(type) {
            this.show_modal_add_plalist = false
            if(type == 'add-playlist') this.$emit('hideModalListPlaylist', type)
        },

        clickAddPlaylist() {
            this.show_modal_add_plalist = true
        }
    },

    watch: {
        show: function(s) {
            if(s) this.fetchPlayList({pagination: this.server_pagination})
        }
    },
}
</script>

<style>

</style>